import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { getTreeCutWork, getTreeYield } from '../engine/forest/treeMath';
import { recordProduced } from '../engine/map/settlement';
import { getBuildingStorage, getEffectiveOutputCap } from '../engine/settlement/utils';

export function runLumberCampTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    const outputCap = getEffectiveOutputCap(settlement, config, 'lumberjack', 'wood');
    const storage = getBuildingStorage(settlement, 'lumberjack');
    if (settlement.buildings.lumberjack.qty <= 0 || settlement.jobs.lumberjacks <= 0) {
        const hadWork = settlement.production.lumberCamp.work !== 0;
        settlement.production.lumberCamp.work = 0;
        return hadWork;
    }

    if (outputCap <= 0 || storage.wood >= outputCap) {
        const hadWork = settlement.production.lumberCamp.work !== 0;
        settlement.production.lumberCamp.work = 0;
        return hadWork;
    }

    if (settlement.regionResources.trees.length === 0) {
        const hadWork = settlement.production.lumberCamp.work !== 0;
        settlement.production.lumberCamp.work = 0;
        return hadWork;
    }

    settlement.regionResources.trees.sort((a, b) => b.age - a.age);
    const targetTree = settlement.regionResources.trees.find((entry) => entry.amount > 0);
    if (targetTree) {
        const targetYield = getTreeYield(config, targetTree.age);
        if (outputCap > 0 && outputCap - storage.wood < targetYield) {
            const hadWork = settlement.production.lumberCamp.work !== 0;
            settlement.production.lumberCamp.work = 0;
            return hadWork;
        }
    }

    const prevWork = settlement.production.lumberCamp.work;
    settlement.production.lumberCamp.work += settlement.jobs.lumberjacks;
    let changed = settlement.production.lumberCamp.work !== prevWork;

    let index = 0;
    while (index < settlement.regionResources.trees.length) {
        const entry = settlement.regionResources.trees[index];
        if (entry.amount <= 0) {
            settlement.regionResources.trees.splice(index, 1);
            continue;
        }
        const requiredTicks = getTreeCutWork(config, entry.age);
        if (settlement.production.lumberCamp.work < requiredTicks) break;
        const yieldAmount = getTreeYield(config, entry.age);
        if (outputCap > 0 && outputCap - storage.wood < yieldAmount) break;
        settlement.production.lumberCamp.work -= requiredTicks;
        entry.amount -= 1;
        storage.wood += yieldAmount;
        recordProduced(settlement, 'wood', yieldAmount);
        changed = true;
        if (entry.amount <= 0) {
            settlement.regionResources.trees.splice(index, 1);
            continue;
        }
        index += 1;
    }

    return changed;
}
